import { Collapse, InteractiveContainer } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import React, { PropsWithChildren, useState } from "react";
import { ReactComponent as QuestionIcon } from "./assets/question.svg";
import { ReactComponent as ChevronIcon } from "./assets/chevron.svg";

export const HelpItemAccordion: React.FC<
  PropsWithChildren<{
    title: string;
    className?: string;
  }>
> = ({ title, className, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={cx(
        "bg-dark shrink-0 overflow-hidden rounded-xl transition-colors hover:bg-[#252B2E]",
        isOpen && "bg-[#252B2E]"
      )}
    >
      <InteractiveContainer
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full items-center justify-between gap-4 p-3 py-2"
      >
        <div className="flex items-center gap-3">
          <QuestionIcon />
          <span
            className={cx(
              "font-secondary text-sm leading-[21px] text-white",
              isOpen && "font-medium"
            )}
          >
            {title}
          </span>
        </div>
        <ChevronIcon
          className={cx({ "rotate-180": isOpen }, "transition-transform")}
        />
      </InteractiveContainer>
      <Collapse isOpen={isOpen}>
        <div
          className={cx(
            "text-dark-200 font-secondary flex flex-col px-5 pt-1 pb-6 text-sm leading-[140%]",
            className
          )}
        >
          {children}
        </div>
      </Collapse>
    </div>
  );
};
